import '../../public_html/vsvars.js'
import './menu.js'

window.vsload = true;